RivalIQ.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.Posts = Backbone.Collection.extend({
        model: RivalIQ.models.Post
    });
});
